import React from 'react';
import { UserAbility } from '../deps.js';
import AdminModal from '../AdminModal.js';

const AbilitiesInfoModal = ({ isOpen, onClose }) => (
  <AdminModal
    isOpen={isOpen}
    onClose={onClose}
    title="What are abilities?"
    actions={(
      <button className="admin-submit-button" onClick={onClose}>
        Got it
      </button>
    )}
  >
    <p style={{ marginBottom: '20px', color: '#666' }}>
      Abilities are specific permissions that determine what actions users can perform. Each role is assigned a set of abilities.
    </p>
    <div className="abilities-info-list">
      {Object.entries(UserAbility)
        .map(([abilityKey, abilityData]) => (
          <div key={abilityKey} className="ability-info-item">
            <div className="ability-info-title">{abilityData.displayName}</div>
            <div className="ability-info-description">
              {abilityData.description}
            </div>
          </div>
        ))}
    </div>
  </AdminModal>
);

export default AbilitiesInfoModal;
